import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form/immutable';

import SelectBox from './SelectBox';
import { getCycles } from '../../actions/cycleActions';
import { getGradeInstances } from '../../actions/gradeInstanceActions';
import { toSelect } from '../../utils/helpers';

class CyclesSelect extends Component {
  componentWillMount() {
    const {
      cycles,
      getCycles,
      gradeInstances,
      getGradeInstances
    } = this.props;
    cycles.isEmpty() && getCycles();
    gradeInstances.isEmpty() && getGradeInstances();
  }

  render() {
    const { cycles, cycleId, gradeInstances } = this.props;
    const currentGrades = gradeInstances.filter(
      grade => grade.get('cycleId') === cycleId
    ).toJS();

    return (
      <div className="multiple-fields">
        <div>
          <Field
            name="cycleId"
            label="Ciclo"
            options={toSelect(cycles.toJS())}
            placeholder="Seleccione un ciclo"
            component={SelectBox}
          />
        </div>
        <div>
          <Field
            name="gradeInstanceId"
            label="Clase"
            options={toSelect(currentGrades)}
            placeholder="Seleccione una clase"
            component={SelectBox}
          />
        </div>
      </div>
    );
  }
}

const { number, func, object } = PropTypes;

CyclesSelect.propTypes = {
  getCycles: func.isRequired,
  getGradeInstances: func.isRequired,
  cycles: object.isRequired,
  gradeInstances: object.isRequired,
  cycleId: number
};

const selector = formValueSelector('student');

const mapState = state => ({
  cycles: state.get('cycle'),
  gradeInstances: state.getIn(['gradeInstance', 'gradeInstances']),
  cycleId: selector(state, 'cycleId')
});

const mapDispatch = dispatch => ({
  getCycles: () => dispatch(getCycles()),
  getGradeInstances: () => dispatch(getGradeInstances())
});

export default connect(mapState, mapDispatch)(CyclesSelect);



// WEBPACK FOOTER //
// ./src/components/common/CyclesSelect.js